/* eslint-disable max-len */
import { StudentTranslations } from '../interfaces/student';

const EnglishStudentTranslations: StudentTranslations = {
  gone: 'This student no longer exists',
  button: {
    create: 'Add student',
  },
  add: {
    title: 'Add student',
    messages: {
      success: 'New student added',
      error: 'Could not add a new student. Please try again in a moment.',
    },
    joinGroup: 'Add to the group “{{group}}”',
    group: {
      added: 'New student added to the group “{{group}}”',
      gone: 'The student has been added, but the group “{{group}}” no longer exists',
      error: 'The student has been added, but could not be added to the group “{{group}}”. You can add them in “Edit group”.',
    },
  },
  access: {
    title: 'Shared lists',
    messages: {
      success: 'yay!',
      error: 'Failed.',
    },
    lists: 'Lists',
    empty: 'This student has no lists yet — share them with the “share” icon next to a list on the lists screen',
    hint: 'Clicking a name makes the list active — the games will use it. Withdrawing sharing does not delete the list; it stays with you.',
    selectList: 'Select the list {{list}}',
    editList: 'Edit the list {{list}}',
    editListTooltip: 'edit list',
    revokeList: 'Withdraw sharing of {{list}}',
    revokeTooltip: 'withdraw sharing',
    revokeMany: 'Withdraw several',
    revokeSelected: 'Withdraw ({{n}})',
    all: 'all',
    confirm: {
      title: 'Withdraw sharing',
      one: 'Are you sure you want to withdraw the list "{{list}}" from {{student}}?',
      many: 'Are you sure you want to withdraw {{n}} lists from {{student}}? The lists themselves stay with you.',
      ok: 'Withdraw',
    },
    revoked: {
      one: 'Sharing has been withdrawn',
      many: 'Sharing withdrawn for {{n}} lists',
      error: 'Could not withdraw sharing',
    },
  },
  list: {
    count: {
      one: '{{n}} student',
      few: '{{n}} students',
      many: '{{n}} students',
    },
    search: 'Search for a student',
    all: 'All',
    ungrouped: 'No group',
    groups: 'Groups',
    inactive: 'account inactive',
    belongsTo: 'Belongs to the group “{{group}}”',
    empty: {
      noStudents: 'You have no students yet — add them with the “Add student” button',
      noMatchInGroup: 'Nobody in the group “{{group}}” matches the search',
      noMatchUngrouped: 'Nobody without a group matches the search',
      noMatch: 'Nobody matches the search',
      emptyGroup: 'This group has no students yet — add them in “Edit group”',
      empty: 'Empty',
    },
    actions: {
      activity: 'activity',
      resendActivation: 'send the activation link again',
      passwordLink: 'send a new password link',
      sharedLists: 'shared lists',
      edit: 'edit',
      delete: 'delete',
    },
  },
  // Na telefonie przycisk „Edytuj grupę” pokazuje samo editShort — editRest dopisuje resztę na szerszym ekranie
  groups: {
    new: 'New group',
    edit: 'Edit group',
    editShort: 'Edit',
    editRest: ' group',
    name: 'Group name',
    students: 'Students',
    selected: 'selected: {{n}}',
    noStudents: 'You have no students yet',
    delete: 'Delete group',
    deleteConfirm: 'Are you sure you want to delete the group “{{group}}”? The students and the lists shared with them stay.',
    messages: {
      nameRequired: 'Enter a group name',
      saved: 'Group “{{group}}” saved',
      added: 'Group “{{group}}” added',
      nameTaken: 'You already have a group with this name',
      gone: 'This group no longer exists',
      studentGone: 'One of the selected students no longer exists. The list has been refreshed — save again.',
      saveError: 'Could not save the group',
      deleteError: 'Could not delete the group',
      deleted: 'Group “{{group}}” deleted',
    },
  },
  activity: {
    title: 'Activity',
    loadError: 'Could not load the activity. Please try again later.',
    workTime: 'time spent',
    practiceDays: 'days with practice',
    daysOf: '{{n}} of {{total}}',
    correct: 'correct',
    noPractice: 'no practice',
    deletedList: 'deleted list',
    emptyPeriod: 'No practice in the last {{n}} days.',
    lastDays: 'Last {{n}} days.',
    rules: 'What counts is the time spent answering in games, and in the Repeat game — listening time (this game adds no answers). Time outside the app does not count. The percentage of correct answers comes only from games that check the answer themselves. The squares under a list are the games in menu order: teal means the student played that game that day.',
    minutes: '{{n}} min',
    underMinute: '<1 min',
    answers: {
      one: '{{n}} answer',
      few: '{{n}} answers',
      many: '{{n}} answers',
    },
  },
  edit: {
    title: 'Editing',
    messages: {
      success: 'Student edited',
      linkSent: 'Saved. A new activation link has been sent to {{email}}',
      error: 'Could not edit the student. Please try again in a moment.',
    },
  },
  activation: {
    title: 'New activation link',
    description: 'Send a new activation link to {{email}}? The previous link will stop working.',
    editAddress: 'Correct the address',
    submit: 'Send',
    cancel: 'Cancel',
    messages: {
      success: 'A new link has been sent to {{email}}',
      error: 'Could not send the link. Please try again in a moment.',
    },
  },
  passwordLink: {
    title: 'New password link',
    description: 'Send a new password link to {{email}}? The current password works until the student sets a new one.',
    messages: {
      success: 'A new password link has been sent to {{email}}',
      error: 'Could not send the link. Please try again in a moment.',
    },
  },
  delete: {
    title: 'Delete',
    description: 'Are you sure you want to delete this student?',
    submit: 'Delete',
    cancel: 'Cancel',
    messages: {
      success: 'The student has been deleted',
      error: 'Could not delete the student',
    },
  },
  studentForm: {
    labels: {
      name: 'First name:',
      surname: 'Last name:',
      email: 'Email:',
      submit: 'Save',
      edit: 'Edit',
    },

    validation: {
      name: {
        required: 'First name is required',
      },
      surname: {
        required: 'Last name is required',
      },
      email: {
        required: 'Email is required',
      },
    },
  },
};

export default EnglishStudentTranslations;
